import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'detail',

  data() {
    return {
      selectOrderLot: 0
    }
  },

  computed: {
    ...mapGetters('category', ['category']),
    ...mapGetters('setting', ['categoryOption']),

    ...mapGetters('detail', [
      'skuId',
      'itemId',
      'itemName',
      'categoryId',
      'categoryName',
      'lifeCycle',
      'leadTime',
      'orderLot',
      'detailConsumption',
      'image'
    ]),

    ...mapGetters('predict', [
      'item',
      'skus',
      'suggestState',
      'predictState',
      'salesSum',
      'salesAmount',
      'profit',
      'stock',
      'consumption',
      'customSalesSum',
      'customSalesAmount',
      'customProfit',
      'customStock',
      'customConsumption'
    ]),

    /**
     * マークダウンサジェスションボタンの活性状態
     * itemまたはskuの事前予測消化率で判定(画面に表示される予測の予測消化率ではない)
     */
    markDown() {
      const rate = this.getCategoryAttr_('under_predict_digest_rate')
      return rate >= 0 && this.detailConsumption <= rate ? false : true
    },

    /**
     * 追加発注サジェスションボタンの活性状態
     * itemまたはskuの事前予測消化率で判定(画面に表示される予測の予測消化率ではない)
     */
    addOrder() {
      const rate = this.getCategoryAttr_('over_predict_digest_rate')
      return rate >= 0 && this.detailConsumption >= rate ? false : true
    },

    // item設定の最低発注ロット
    lots() {
      this.selectOrderLot = this.orderLot
      return this.setSelectbox_('lot')
    },

    // 動的CSS
    csspredictState() {
      return this.predictState ? 'nodisplay' : ''
    }
  },

  methods: {
    ...mapActions('detail', ['setItemset']),

    ...mapActions('predict', [
      'getPredictItem',
      'getSuggestOrder',
      'getSuggestOrderSku',
      'getSuggestDiscount',
      'getSuggestDiscountSku'
    ]),

    ...mapActions('setting', [
      'getCategoryOptions',
      'getBrandOptions'
    ]),

    /**
     * 追加発注サジェスションボタン押下
     * item単位とsku単位で処理が異なる
     */
    exeSuggestOrder() {
      this.skuId ? this.getSuggestOrderSku() : this.getSuggestOrder()
    },

    /**
     * マークダウンサジェスションボタン押下
     * item単位とsku単位で処理が異なる
     */
    exeSuggestDiscount() {
      this.skuId ? this.getSuggestDiscountSku() : this.getSuggestDiscount()
    },

    /**
     * 指定したカテゴリ設定を取得
     */
    getCategoryAttr_(key) {
      if (_.has(this.category, this.categoryId) &&
        _.has(this.category[this.categoryId], key)) {
        return this.category[this.categoryId][key]
      }
      return -1
    },

    /**
     * item設定のselectbox用データ構築
     * デフォルトにはカテゴリ設定の値を設定
     */
    setSelectbox_(key) {
      if (!this.categoryOption) return []

      const list = []
      const idx = _.findIndex(this.categoryOption, { key: key })
      const targetValue = this.getCategoryAttr_(key)

      _.forEach(this.categoryOption[idx].values, val => {
        list.push({
          text: val + (targetValue === val ? '*' : ''),
          value: val
        })
      })
      return list
    },

    /**
     * item設定更新
     * 更新したら再度予測処理を行う
     */
    async updateItemset() {
      await this.setItemset({
        itemId: this.itemId,
        lifeCycle: this.lifeCycle,
        leadTime: this.leadTime,
        lot: this.selectOrderLot
      })

      this.getPredictItem({
        itemId: this.itemId
      })
    }
  },

  created() {
    this.getCategoryOptions()
  }
}



// WEBPACK FOOTER //
// ./src/components/aftersale/predict/detail/detail.js